import Title from './title';

export * from './title';

export default Title;
